export default __webpack_public_path__ + "static/media/basketIcon.5a3bde03.svg";